import React from "react"
import BrandEditorialMenuItem from "../BrandEditorialMenuItem"

interface Props {
  menuItems: any[]
}

const BrandEditorialMenu = ({ menuItems }: Props) => {
  return (
    <div className="my-4">
      {menuItems.map((x: any, i: number) => (
        <BrandEditorialMenuItem
          item={x}
          key={i}
          defaultExpanded={i === 0}
          level={0}
        />
      ))}
    </div>
  )
}

export default BrandEditorialMenu
